<template>
  <TimelineHandler>
    <template #default="{ loading, timeline, dates, sliderDate, handleUpdateTimeline, handleUpdateSliderDate }">
      <div
        ref="timelineRef"
        class="app-timeline"
        :class="{ 'app-timeline--inline': dates.length === 2 && !isSmView }"
      >
        <div class="app-timeline__container">
          <slot
            :is-short-view="isMdView"
          />
        </div>
        <DSPeriodScroller
          :timeline
          :dates
          :selected="sliderDate"
          :disabled
          :loading
          :class="{ 'w-auto! ml-auto -my-1.5': dates.length === 2 }"
          @update:timeline="handleUpdateTimeline"
          @update:selected="handleUpdateSliderDate"
        />
      </div>
    </template>
  </TimelineHandler>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'
import { useResizeObserver, useThrottleFn } from '@vueuse/core'
import { DSPeriodScroller } from '@ds'
import TimelineHandler from './TimelineHandler.vue'

const BREAKPOINT_MD = 680
const BREAKPOINT_SM = 480
const THROTTLE_DELAY = 300

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const timelineRef = useTemplateRef('timelineRef')
  
const isMdView = ref(false)
const isSmView = ref(false)

useResizeObserver(timelineRef, useThrottleFn(entry => {
  isMdView.value = entry[0]?.contentRect.width < BREAKPOINT_MD
  isSmView.value = entry[0]?.contentRect.width < BREAKPOINT_SM
}, THROTTLE_DELAY))
</script>

<style>
.app-timeline {
  @apply -mx-4 sm:-mx-default -mt-5;
  @apply pt-5 px-4 sm:px-default pb-2;
  @apply bg-background;

  &--inline {
    @apply sm:flex sm:items-center sm:gap-2;
  }

  &__container {
    @apply flex items-center;
    @apply gap-2 mb-4 md:mb-1.5;
  }

  &--inline &__container {
    @apply sm:mb-0;
  }
}
</style>
